import {field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class ReceiveOrderReportData extends ReportData<ReceiveOrderReportData> {
    @field receivingId: number;
}
